import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import Layout from 'components/Layout';
import Breadcrumbs from 'components/Breadcrumbs';
import CombinedForm from 'components/CombinedForm';

const CombinedFormLayout = ({ translationKey, children }) => {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${translationKey}.pageTitle`)}>
      <div className="o-retain o-retain--wall">
        <div className="c-sidebar-layout">
          <div className="c-sidebar-layout__main">
            <Breadcrumbs
              links={[
                {
                  label: t(`${translationKey}.pageHeading`),
                  href: '/cv-uploaden',
                },
              ]}
            />

            <h1>{t(`${translationKey}.pageHeading`)}</h1>

            {children}
            <CombinedForm translationKey={translationKey} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

CombinedFormLayout.propTypes = {
  translationKey: PropTypes.string.isRequired,
  children: PropTypes.element,
};

export default CombinedFormLayout;
